<template>
    <div class="content-line">
        <!-- <Card>
            <div class="condition-line">
                <div class="block">
                    <label>店铺:</label>
                    <el-select v-model="entityID" placeholder="选择实体" @change="changeTitle" size="mini">
                        <el-option v-for="item in entitys" :key="item.EntityID" :label="item.EntityName" :value="item.EntityID"> </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <label>日期:</label>
                    <el-date-picker v-model="date" size="mini" type="date" placeholder="选择日期"> </el-date-picker>
                </div>
                <div class="block">
                    <el-button type="primary" size="mini" @click="loadData">查询</el-button>
                </div>
            </div>
        </Card> -->
        <ParamsHeader @searchParams="handleInit"> </ParamsHeader>
    </div>
    <div class="content-line">
        <Card>
            <div class="total-line">
                <template v-for="(item, index) in dataList" :key="index">
                    <TotalBlock v-bind="item"></TotalBlock>
                    <div class="split-line" v-if="index < dataList.length - 1"></div>
                </template>
            </div>
        </Card>
    </div>
    <div class="content-line">
        <Card>
            <template v-slot:header>
                <h2>客流趋势</h2>
            </template>
            <div class="card-content" ref="cardcontent">
                <ChartMap class="chart-normal" ref="chart"></ChartMap>
            </div>
        </Card>
    </div>
    <div class="content-line">
        <Card>
            <template v-slot:header>
                <h2>详细数据</h2>
            </template>
            <div class="card-content" ref="cardcontent">
                <el-table :data="data.Details" stripe style="width: 100%">
                    <el-table-column prop="Name" label="名称" sortable> </el-table-column>
                    <el-table-column prop="FlowData" label="客流量 (人次)" sortable> </el-table-column>
                    <el-table-column prop="FlowDensity" label="集客力 (人/㎡)" sortable> </el-table-column>
                    <el-table-column prop="LevelAvgFlowData" label="楼层平均客流 (人次)" sortable> </el-table-column>
                    <el-table-column prop="ModelAvgFlowData" label="业态平均客流 (人次)" sortable> </el-table-column>
                    <el-table-column prop="LastFlowData" label="上周同日 (人次)" sortable> </el-table-column>
                    <el-table-column label="较上周同日" sortable>
                        <template v-slot="scope">
                            <span v-if="scope.row.FlowData > scope.row.LastFlowData && scope.row.LastFlowData > 0" class="sk-number-up">
                                {{ formatData(((scope.row.FlowData - scope.row.LastFlowData) * 100) / scope.row.LastFlowData) }}↑
                            </span>
                            <span v-else-if="scope.row.FlowData < scope.row.LastFlowData && scope.row.LastFlowData > 0" class="sk-number-down">
                                {{ formatData(((scope.row.FlowData - scope.row.LastFlowData) * 100) / scope.row.LastFlowData) }}↓</span
                            >
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="LastYearFlowData" label="去年同日 (人次)" sortable> </el-table-column>
                    <el-table-column label="较去年同日" sortable>
                        <template v-slot="scope">
                            <span v-if="scope.row.FlowData > scope.row.LastYearFlowData && scope.row.LastYearFlowData > 0" class="sk-number-up">
                                {{ formatData(((scope.row.FlowData - scope.row.LastYearFlowData) * 100) / scope.row.LastYearFlowData) }}↑
                            </span>
                            <span
                                v-else-if="scope.row.FlowData < scope.row.LastYearFlowData && scope.row.LastYearFlowData > 0"
                                class="sk-number-down"
                            >
                                {{ formatData(((scope.row.FlowData - scope.row.LastYearFlowData) * 100) / scope.row.LastYearFlowData) }}↓
                            </span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </Card>
    </div>
</template>
<script>
import TotalBlock from "../../components/TotalBlock.vue";
import ParamsHeader from "../components/ParamsHeader";
export default {
    name: "day",
    data() {
        return {
            dataList: [],
            entitys: { type: Array },
            entityID: "",
            date: "",
            max1: 100,
            max2: 100,
            data: {
                Details: [],
            },
            searchParam: {
                BeginTime: "",
                EndTime: "",
                TotalType: 2,
                EntityID: null,
            },
        };
    },
    created() {
        this.date = new Date().format("yyyy-MM-dd");
    },
    mounted() {},
    components: { TotalBlock, ParamsHeader },
    methods: {
        // 参数适配器
        searchParamsAdaptor(params) {
            this.searchParam.BeginTime = params.dateRan[0];
            this.searchParam.EndTime = params.dateRan[1];
            this.searchParam.TotalType = params.type;
            this.searchParam.EntityID = params.entityID;
        },
        handleInit(p) {
            this.searchParamsAdaptor(p);
            this.loadData();
        },
        formatData(v) {
            return v.format(2);
        },
        loadData() {
            this.$ajax.post("/FlowData/GetShopFlowTotal", this.searchParam).then((result) => {
                this.data = result.Data;
                this.buildTotalData();
                this.buildChartData();
            });
        },
        buildTotalData() {
            if (this.data) {
                let list = [
                    {
                        title: "客流量 (人次)",
                        data: {
                            d: this.data.FlowData,
                            d1: this.data.LastFlowData,
                        },
                        showDS2: false,
                        showDS3: false,
                        dec: 0,
                    },
                    {
                        title: "集客力 (人/㎡)",
                        data: {
                            d: this.data.FlowData,
                            d1: this.data.LastFlowData,
                        },
                        showDS2: false,
                        showDS3: false,
                        dec: 2,
                    },
                    {
                        title: "店铺日均客流 (人次)",
                        data: {
                            d: this.data.AvgFlowData,
                            d1: this.data.LastAvgFlowData,
                        },
                        showDS2: false,
                        showDS3: false,
                        dec: 0,
                    },
                    {
                        title: "楼层日均客流 (人次)",
                        data: {
                            d: this.data.LevelAvgFlowData,
                            d1: this.data.LastLevelAvgFlowData,
                        },
                        showDS2: false,
                        showDS3: false,
                        dec: 0,
                    },
                    {
                        title: "业态日均客流 (人次)",
                        data: {
                            d: this.data.ModelAvgFlowData,
                            d1: this.data.LastModelAvgFlowData,
                        },
                        showDS2: false,
                        showDS3: false,
                        dec: 0,
                    },
                ];
                this.dataList = list;
            }
        },
        buildChartData() {
            let x = [];
            let d1 = [];
            let d2 = [];
            let d3 = [];
            let d4 = [];
            for (let i = 0; i < this.data.Details.length; i++) {
                x.push(this.data.Details[i].Name);
                d1.push(this.data.Details[i].FlowData);
                d2.push(this.data.Details[i].FlowDensity);
                d3.push(this.data.Details[i].LevelAvgFlowDensity);
                d4.push(this.data.Details[i].ModelAvgFlowData);
                this.max1 = Math.max(this.max1, this.data.Details[i].FlowData);
                this.max2 = Math.max(
                    this.max2,
                    this.data.Details[i].FlowDensity,
                    this.data.Details[i].LevelAvgFlowDensity,
                    this.data.Details[i].ModelAvgFlowData
                );
            }
            let opt = this.getOptions(x, d1, d2, d3, d4);
            this.$refs.chart.setData(opt);
        },
        getOptions(x, d1, d2, d3, d4) {
            let option = {
                color: ["#599bf7", "#ef807c", "#ffc62e", "#ff9631", "#87d14b"],
                title: {},
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                legend: {
                    data: ["客流量", "店铺集客力", "楼层集客力", "业态平均集客力"],
                    bottom: "0px",
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "40px",
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                        dataView: {},
                    },
                    right: "20px",
                },
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: x,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: [
                    {
                        name: "客流量",
                        type: "bar",
                        data: d1,
                    },
                    {
                        name: "店铺集客力",
                        type: "line",
                        data: d2,
                        yAxisIndex: 1,
                    },
                    {
                        name: "楼层集客力",
                        type: "line",
                        data: d3,
                        yAxisIndex: 1,
                    },
                    {
                        name: "业态平均集客力",
                        type: "line",
                        data: d4,
                        yAxisIndex: 1,
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "客流量",
                        min: 0,
                        max: this.max1,
                        axisLabel: {},
                    },
                    {
                        type: "value",
                        name: "集客力",
                        min: 0,
                        max: this.max2,
                        axisLabel: {},
                    },
                ],
            };
            return option;
        },
    },
};
</script>
